import {styled} from "@mui/material/styles"
import {Drawer as MUIDrawer} from "@mui/material"
import {breakpoints} from "@next/ux-fabric"
import {Anchor} from "../../config/constants"

export const DrawerContainer = styled(MUIDrawer)`
    && > div:first-of-type {
        background: ${({theme}) => theme.uxfabric.components.backdrop.default.backgroundColor};
    }
    &&.drawer > div:nth-of-type(3) {
        width: calc(100% - 2.75rem);
        @media (max-width: ${breakpoints.values.md - 1}px) {
            background: #fff;
        }
    }
`
type CloseIconProps = {
    anchor: Anchor | undefined
}

export const CloseIcon = styled("img")`
    margin: auto;
`

export const IconContainer = styled("div", {
    shouldForwardProp: p => p !== "anchor",
})<CloseIconProps>`
    position: fixed;
    top: 0;
    left: ${props => (props.anchor === "left" ? "unset" : 0)};
    right: ${props => (props.anchor === "right" ? "unset" : 0)};
    width: 2.75rem;
    height: 2.75rem;
    align-content: center;
    text-align: center;
    img {
        cursor: default;
    }

    .default {
        fill: ${({theme}) => theme.uxfabric.components.drawer.default.iconColor};
    }
`
